module.exports = __webpack_public_path__ + "static/media/protocol-test.163663c2.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/protocol-test.png
// module id = 44
// module chunks = 1